export const ACTION_PREFIX = 'MODULE/LOG'
